import React, { useState } from 'react';

interface TabControlProps extends React.PropsWithChildren<{}> {
    tabs: string[];
}

function buildTabClassName(index: number, activeIndex: number, tabCount: number) {
    const classNames = ['k-item', 'k-state-default'];

    if (index === 0) {
        classNames.push('k-first');
    }

    if (index === tabCount - 1) {
        classNames.push('k-last');
    }

    if (index === activeIndex) {
        classNames.push('k-tab-on-top', 'k-state-active');
    }

    return classNames.join(' ');
}

const TabControl: React.FC<TabControlProps> = ({ tabs, children }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const childArray = React.Children.toArray(children);

    return (
        <div className="k-tabstrip-wrapper">
            <div className="tab-control k-widget k-header k-tabstrip k-floatwrap k-tabstrip-top" data-role="tabstrip">
                <ul className="k-tabstrip-items k-reset">
                    {tabs.map((tab, i) => (
                        <li
                            key={tab}
                            className={buildTabClassName(i, activeIndex, tabs.length)}
                            onClick={() => setActiveIndex(i)}
                        >
                            <span className="k-loading k-complete" />
                            <span className="k-link">{tab}</span>
                        </li>
                    ))}
                </ul>
                {childArray.map((child, i) => {
                    const isActive = i === activeIndex;

                    return (
                        <div
                            key={i}
                            className={isActive ? 'k-content k-state-active' : 'k-content'}
                        >
                            {child}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TabControl;
